var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 41,
    viewBox: "0 0 64 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 40.333C49.6731 40.333 64 37.199 64 33.333C64 29.467 49.6731 26.333 32 26.333C14.3269 26.333 0 29.467 0 33.333C0 37.199 14.3269 40.333 32 40.333Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0928 0.833008H42.9072C43.4332 0.833104 44.004 1.16929 44.4297 1.85449L44.4512 1.89062L44.4795 1.92188L54.5 13.2812V21.833H9.5V13.2822L19.5205 1.9209L19.5488 1.88965L19.5703 1.85449C19.996 1.17012 20.5666 0.833105 21.0928 0.833008Z",
    fill: "white",
    stroke: "#DBDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1602 13.833C20.5855 13.8331 21.0059 14.0603 21.3369 14.4971C21.6682 14.9343 21.8867 15.558 21.8867 16.2607V16.2832C21.8868 18.0365 23.0036 19.6836 24.624 19.6836H39.376C40.1803 19.6836 40.8757 19.2559 41.3535 18.6338C41.8309 18.0121 42.1132 17.1748 42.1133 16.2715V16.2637C42.1134 15.5609 42.3317 14.9369 42.6631 14.499C42.9531 14.1159 43.3115 13.8934 43.6816 13.8438L43.8408 13.833H54.5V31.4697C54.5 32.431 54.2002 33.2884 53.7383 33.8945C53.2766 34.5003 52.675 34.833 52.0498 34.833H11.9502C11.3252 34.833 10.7235 34.5004 10.2617 33.8945C9.79972 33.2882 9.5 32.4305 9.5 31.4697V13.833H20.1602Z",
    fill: "#FAFAFA",
    stroke: "#DBDBDB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty_box.70b1320d106c8c0a2bb23da66d1aec5a.svg";
export { ForwardRef as ReactComponent };